import { toast } from "sonner";

import { fetchApi } from "@/lib/api";

/** Below this the recording is a mis-tap, not speech. */
export const MIN_AUDIO_BYTES = 1000;

/**
 * POST a recording to ``/recognitions/voice-extract``. ``onSend`` fires once
 * the upload starts. Too short or a failed extract toasts and returns null.
 */
export async function voiceExtract<T>(blob: Blob, name: string, onSend?: () => void): Promise<T | null> {
  if (blob.size < MIN_AUDIO_BYTES) {
    toast.error("That was too short. Try again?");
    return null;
  }
  onSend?.();
  const form = new FormData();
  form.append("audio", blob, `${name}.${blob.type.includes("webm") ? "webm" : "mp4"}`);
  try {
    return await fetchApi("/recognitions/voice-extract", { method: "POST", body: form });
  } catch (err: unknown) {
    const msg = err instanceof Error ? err.message : "Voice input unavailable right now";
    toast.error(msg + " — try typing instead");
    return null;
  }
}
